import Help from "@material-symbols/svg-500/rounded/help.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const HelpIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Help });
	return <Icon />;
};

export default memo(HelpIcon);
